import { Trans } from 'react-i18next'

import { BuilderMenu, IActionFormProps } from '@makyoapp/makyo-common'
import { Menu16 } from '@makyoapp/makyo-icon/icon'
import { Button, ButtonVariant, Field, Label, SelectDropdown } from '@makyoapp/makyo-ui'

import { useForm } from '@/lib/use-form'
import { useAppBuilderContext } from '@/context/AppBuilderContext'
import { useVariableTextSingleCell } from '@/hooks/__project__/useVariableTextSingleCell'
import { isEmpty } from '@/shared/utils'

const RenderMenuOption = ({ menu }: { menu: BuilderMenu }) => {
  const menuTitle = useVariableTextSingleCell(menu.title)
  return (
    <div className='flex-c'>
      <Menu16 />
      <div>{menuTitle}</div>
    </div>
  )
}

export default function ActFormOpenMenu({ onSubmit, onDismiss, initialData }: IActionFormProps) {
  const { menus } = useAppBuilderContext()

  const { form, onSubmit: onFormSubmit } = useForm({
    defaultValues: {
      menu: initialData?.menu ?? menus[0]?.id ?? '',
    },
    validate(values, setError) {
      if (!values.menu?.trim().length) {
        setError('menu', 'Please choose a menu')
      }
    },
  })

  const handleSubmit = onFormSubmit((data) => {
    onSubmit(data)
  })

  const value = form.getValues('menu')
  const invalidForm = isEmpty(value) || !!form.errors

  return (
    <div>
      <div className='p-4'>
        <Field>
          <Label required>Select Menu</Label>

          <div className='flex-1'>
            <SelectDropdown
              value={menus.find(({ id }) => id === form.getValues('menu'))}
              onChange={(opt, e) => {
                e.preventDefault()
                e.stopPropagation()
                form.setValues('menu', opt.id)
              }}
              portalMenu
              menuZIndex='z-302'
              menuContainerClassName='mk-ag-sdd'
              options={menus}
              optionLabel={(opt) => `${opt?.id} ${opt?.title}`}
              renderOption={(opt) => <RenderMenuOption menu={opt} />}
            />
            <div className='mt-1 text-m-sm red h-[17px]'>{form.errors?.menu}</div>
          </div>
        </Field>
      </div>

      <div className='px-4 py-2 border-t bdr flex justify-between items-center'>
        <Button variant={ButtonVariant.Outlined} onClick={onDismiss}>
          <Trans>Cancel</Trans>
        </Button>
        <Button onClick={handleSubmit} disabled={invalidForm}>
          <Trans>Save</Trans>
        </Button>
      </div>
    </div>
  )
}
